// The one-line field most forms are made of, bound to a form object, a
// change(name, value) setter and the server's field errors. Pages call the
// returned function as field('name', 'Label', { wide, type, step, min, help,
// placeholder }).

import { Input } from './components/ui/index.js'

export function fieldFactory({ form, change, fieldErrors, idPrefix = '' }) {
  return (name, label, extra = {}) => (
    <Input
      id={`${idPrefix}${name}`}
      className={extra.wide ? 'span-2' : undefined}
      label={label}
      type={extra.type ?? 'text'}
      step={extra.step}
      min={extra.min}
      value={form[name]}
      onChange={(event) => change(name, event.target.value)}
      error={fieldErrors[name]}
      help={extra.help}
      placeholder={extra.placeholder}
    />
  )
}
